import cn from "../../../utils/classes"
import { Typography, typographyTypes } from "./Typography"

export interface BubbleIndicatorProps {
  /** The text to be displayed inside the bubble. */
  text: string
  /** Additional CSS classes to override the default bubble styles. */
  bubbleStyleOverrides?: string
  /** Additional CSS classes to override the default typography styles. */
  typographyStyleOverrides?: string
}

const BubbleIndicator: React.FC<BubbleIndicatorProps> = ({
  text,
  bubbleStyleOverrides,
  typographyStyleOverrides,
}) => {
  const defaultStyles = ["px-1/2", "bg-primary-blue", "rounded-full", "w-fit"]
  const bubbleClassName = cn(defaultStyles, bubbleStyleOverrides)

  return (
    <div className={bubbleClassName}>
      <Typography
        text={text}
        variant={typographyTypes.NORMAL}
        styleOverrides={`text-white font-semibold ${typographyStyleOverrides}`}
      />
    </div>
  )
}

export default BubbleIndicator
